import { motion } from "framer-motion";

/**
 * PageContainer — fade+rise transition + consistent paddings.
 * Use on every page.
 */
export default function PageContainer({ children, className = "", testid }) {
  return (
    <motion.section
      data-testid={testid}
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -6 }}
      transition={{ duration: 0.42, ease: [0.22, 1, 0.36, 1] }}
      className={`px-5 sm:px-6 pt-6 ${className}`}
    >
      {children}
    </motion.section>
  );
}
